<template>
  <div class="bg-cover bg-center bg-no-repeat bg-custom-login-image">
    <div class="flex items-center justify-center h-screen px-6 bg-gray-900/80">
      <div
        class="max-w-sm p-6 bg-custom-blue shadow-md w-[400px] h-[520px] top-[156px] left-[520px] rounded-[16px]"
      >
        <div class="flex items-center justify-center">
          <img
            class="object-cover w-[150px] h-[64px] top-[13px]"
            src="@/assets/images/Jiji-Health-White-Logo.png"
            alt="Your avatar"
          />
        </div>
        <div class="flex justify-center font-thin text-white text-xs">
          <div>Welcome to Jiji Health,</div>
        </div>
        <div class="flex justify-center font-thin text-white text-xs">
          <div>
            Advancing <span class="text-custom-yellow">Healthcare</span> Tech!
          </div>
        </div>

        <form class="mt-8 px-3" @submit.prevent="login">
          <label class="block">
            <span class="text-sm text-white">Email</span>
            <input
              type="text"
              class="block w-full mt-1 px-3 py-2 dark:placeholder-gray-400 rounded-md"
              v-model="email"
              placeholder="johndoe@mail.com or 0712345678"
            />
          </label>

          <label class="block mt-4 relative">
            <span class="text-sm text-white">Password</span>
            <input
              ref="passwordField"
              :type="passwordVisible ? 'text' : 'password'"
              class="block w-full mt-1 px-3 py-2 dark:placeholder-gray-400 rounded-md"
              v-model="password"
              placeholder="your password"
            />
            <div
              class="absolute inset-y-4 py-8 right-0 pr-3 flex items-center text-sm leading-5"
            >
              <button
                type="button"
                id="togglePassword"
                class="text-gray-500 focus:outline-none focus:text-gray-600 hover:text-gray-600"
                @click="togglePasswordVisibility"
              >
                <svg
                  v-if="passwordVisible"
                  class="w-6 h-6 text-gray-800 dark:text-gray-500"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="m4 15.6 3.055-3.056A4.913 4.913 0 0 1 7 12.012a5.006 5.006 0 0 1 5-5c.178.009.356.027.532.054l1.744-1.744A8.973 8.973 0 0 0 12 5.012c-5.388 0-10 5.336-10 7A6.49 6.49 0 0 0 4 15.6Z"
                  />
                  <path
                    d="m14.7 10.726 4.995-5.007A.998.998 0 0 0 18.99 4a1 1 0 0 0-.71.305l-4.995 5.007a2.98 2.98 0 0 0-.588-.21l-.035-.01a2.981 2.981 0 0 0-3.584 3.583c0 .012.008.022.01.033.05.204.12.402.211.59l-4.995 4.983a1 1 0 1 0 1.414 1.414l4.995-4.983c.189.091.386.162.59.211.011 0 .021.007.033.01a2.982 2.982 0 0 0 3.584-3.584c0-.012-.008-.023-.011-.035a3.05 3.05 0 0 0-.21-.588Z"
                  />
                  <path
                    d="m19.821 8.605-2.857 2.857a4.952 4.952 0 0 1-5.514 5.514l-1.785 1.785c.767.166 1.55.25 2.335.251 6.453 0 10-5.258 10-7 0-1.166-1.637-2.874-2.179-3.407Z"
                  />
                </svg>
                <svg
                  v-else
                  class="w-6 h-6 text-gray-500"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke="currentColor"
                    stroke-width="2"
                    d="M21 12c0 1.2-4.03 6-9 6s-9-4.8-9-6c0-1.2 4.03-6 9-6s9 4.8 9 6Z"
                  />
                  <path
                    stroke="currentColor"
                    stroke-width="2"
                    d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                  />
                </svg>
              </button>
            </div>
          </label>

          <div class="mt-6">
            <button
              type="submit"
              @disabled="submitting"
              class="w-full font-semibold leading-relaxed px-4 py-2 text-md text-center text-white bg-custom-yellow rounded-md focus:outline-none hover:text-custom-blue"
            >
              <span v-if="submitting" class="flex items-center justify-center">
                <img :src="loaderUrl" alt="Logging In.." class="w-6 h-6" />
              </span>
              <span v-else> Log In </span>
            </button>
          </div>
          <div class="flex justify-center mt-4 text-white">
            <div>
              <a class="block text-sm hover:underline" href="#"
                >Forgot your password?</a
              >
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import apiClient from "@/services/api";
import loaderUrl from "@/assets/images/loader.gif";

export default {
  name: "LoginPage",
  data() {
    return {
      email: "",
      password: "",
      passwordVisible: false,
      errorMessage: "",
      loaderUrl: loaderUrl,
      submitting: false,
      billDue: {},
      billGracePeriod: process.env.VUE_APP_BILL_GRACE_PERIOD,
    };
  },
  methods: {
    validateFields() {
      const emptyFields = [];
      if (!this.email) emptyFields.push("Email/Phone Number");
      if (!this.password) emptyFields.push("Password");

      return emptyFields;
    },

    async login() {
      this.errorMessage = "";

      const emptyFields = this.validateFields();
      if (emptyFields.length > 0) {
        this.errorMessage = `Please fill the following field(s): ${emptyFields.join(
          ", "
        )}`;
        this.hideErrorMessage();
        return;
      }

      this.submitting = true;
      try {
        const response = await apiClient.login({
          Username: this.email,
          password: this.password,
        });

        if (!response.success) {
          this.$toast.warning("You entered wrong username or password.");
          return;
        }
        const { token, user, login_log_id } = response.data;
        localStorage.setItem("token", token);
        localStorage.setItem("user", JSON.stringify(user));
        if (login_log_id) localStorage.setItem("login_log_id", login_log_id);
        else localStorage.removeItem("login_log_id");
        this.submitting = false;
        this.$toast.success("Log in successful, welcome back.");

        this.handleRedirect(user.UserType)

      } catch (error) {
        this.submitting = false;

        if (error.status === 423) {
          const suspensionMessage = error.message.replace(/^Login failed:\s*/i, "")
          this.$toast.open({
            type: "warning",
            duration: 0,
            dismissible: true,
            message: `
              <div class="flex items-start justify-between gap-4 max-w-xs sm:max-w-sm">
                <div>
                  <strong class="block text-md font-semibold mb-1">Account Suspended</strong>
                  <span class="text-md leading-snug">${suspensionMessage}</span>
                </div>
                <span class="text-xl leading-none shrink-0" title="Click to dismiss">&times;</span>
              </div>
            `,
          });
          this.errorMessage = suspensionMessage;
        } else {
          this.$toast.warning("You entered wrong username or password.");
          this.errorMessage = "Wrong email or password";
        }
        this.hideErrorMessage();
      }
    },
    async handleRedirect(userType){
      await this.getPendingBill();
      if (this.billDue){
        const pastDue = this.checkWeatherDueBillPastGracePeriod();
        if (pastDue && userType !== "Facility Admin") {
          this.$router.push("/general-system-bill-overdue");
        } else {
          await this.redirectToUserDashboard(userType);
        }
      } else{
        await this.redirectToUserDashboard(userType);
      }
    },
    async getPendingBill() {
      try {
        const response = await apiClient.fetchBillDue();
        if (response.success) {
          this.billDue = response.data;
        } else {
          this.$toast.error('Failed to fetch bill due');
        }
      } catch (error) {
        this.$toast.error('Failed to register patient');
        console.log(error);
      }
    },
    checkWeatherDueBillPastGracePeriod(){
      const dueDateInput = this.billDue.month;
      const gracePeriod = process.env.VUE_APP_BILL_GRACE_PERIOD;

      if (dueDateInput) {
        // Parse dueDateInput to get the year and month
        let year, month;
        if (typeof dueDateInput === 'string') {
          // Assuming format like "YYYY-MM"
          const [yearStr, monthStr] = dueDateInput.split('-');
          year = parseInt(yearStr, 10);
          month = parseInt(monthStr, 10) - 1; // JavaScript months are 0-based
        } else if (dueDateInput instanceof Date) {
          year = dueDateInput.getFullYear();
          month = dueDateInput.getMonth();
        } else {
          console.error('Invalid dueDate format');
          return false;
        }

        // Calculate the last day of the month
        const dueDateObj = new Date(year, month + 1, 0); // Setting day to 0 of next month gives last day of current month
        const today = new Date();

        // Calculate the difference in days
        const timeDiff = today.getTime() - dueDateObj.getTime();
        const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

        console.log("End of Month Due Date:", dueDateObj.toISOString().split('T')[0]);
        console.log("Days difference:", daysDiff);
        console.log("billGracePeriod:", gracePeriod);

        return daysDiff > gracePeriod;
      }

      console.warn('No due date provided');
      return false;
    },
    hideErrorMessage() {
      setTimeout(() => {
        this.errorMessage = "";
      }, 4000);
    },

    togglePasswordVisibility() {
      this.passwordVisible = !this.passwordVisible;
      const passwordField = this.$refs.passwordField;
      passwordField.type = this.passwordVisible ? "text" : "password";
    },

   async redirectToUserDashboard(userType) {
      await this.getPendingBill();
      if (userType === "Receptionist") {
        this.$router.push("/reception");
      } else if (userType === "Nurse") {
        this.$router.push("/triage");
      } else if (userType === "Doctor") {
        this.$router.push("/consultation");
      } else if (userType === "Lab Tech") {
        this.$router.push("/laboratory");
      } else if (userType === "Radiology") {
        this.$router.push("/radiology");
      } else if (userType === "Facility Admin") {
        this.$router.push("/facility-services");
      } else if (userType === "Cashier") {
        this.$router.push("/cashier");
      } else if (userType === "Pharmacist") {
        this.$router.push("/pharmacy");
      } else if (userType === "Radiologist") {
        this.$router.push("/radiology");
      }
      else {
        this.$router.push("/reception"); // Redirect to home or login if no role is found
      }
    },
  },
};
</script>

<style scoped>
/* CSS for the fade transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
</style>
